import React, { useEffect, useState, useRef } from "react";
import { FaSearch, FaUserPlus } from "react-icons/fa";
import { Link } from "react-router-dom";
import { getcountries, getstates, getcities, filterpost } from "../../Api/iron";
import Loader2 from "../DashboardComponents/Loader/Loader2";
import { Tab, Nav, Form, Modal } from "react-bootstrap";
import { API_URL } from "../../Api/config";
import { getCurrentUser } from "../../Api/auth";
import { MdAttachEmail } from "react-icons/md";
import { IoCall, IoClose, IoResize } from "react-icons/io5";
import { useParams } from 'react-router-dom';
import Header from "../../Components/Header/Header";
import address from "../../assets/images/address.svg";
import webpage from "../../assets/images/webpage.svg";
import expand from "../../assets/images/expand.svg";
import ContactUs from "../../Components/ContactUs/ContactUs";

function FitterProfile() {
  const [isLoading, setIsLoading] = useState(true);
  const params = useParams();

  const [validated, setValidated] = useState(false);
  const [countrylist, setCountrylist] = useState([]);
  const [statelist, setStatelist] = useState([]);
  const [citylist, setCitylist] = useState([]);
  const [fitterdata, setfitterdata] = useState([]);
  const [fitterposts, setfitterPosts] = useState([]);


  const [databaseimage, setDatabaseImage] = useState(null);
  const [databasecoverimage, setdatabaseCoverImage] = useState(null);

  const [selectedImage, setSelectedImage] = useState(null);

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [showbiovideo, setShowbiovideo] = useState(false);
  const handleClosebiovideo = () => setShowbiovideo(false);
  const handleShowbiovideo = () => setShowbiovideo(true);

  useEffect(() => {
    getcountydata();
    getfitterdata();
  }, []);

  const getfitterdata = () => {
    setIsLoading(true);

    const data = {
      fitter_id: params.id
    }

    filterpost(data).then((response) => {
      if (!response.data.status) {
      } else {
        const data = response.data.data;
        setfitterdata(data[0]);
        getstatedata(response.data.data[0].country);
        getcitydata(response.data.data[0].state);
        setfitterPosts(response.data.data[0].postdata);
        setdatabaseCoverImage(response.data.data[0].cover_image)
        setDatabaseImage(response.data.data[0].profile_image)
      }
    })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const getcountydata = () => {
    setIsLoading(true);

    getcountries().then((response) => {
      if (!response.data.status) {
      } else {
        const data = response.data.data;
        setCountrylist(data);
      }
    })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const getstatedata = (country_id) => {
    setIsLoading(true);

    const data = {
      country_id: country_id,
    };

    getstates(data).then((response) => {
      if (!response.data.status) {
      } else {
        const data = response.data.data;
        setStatelist(data);
      }
    })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const getcitydata = (state_id) => {
    setIsLoading(true);

    const data = {
      state_id: state_id,
    };

    getcities(data).then((response) => {
      if (!response.data.status) {
        // setErrors();
        console.log(response.data.error);
      } else {
        const data = response.data.data;
        setCitylist(data);
      }
    })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const [edittrue, setEdittrue] = useState(false);

  const stateName = statelist.find(item => item._id === fitterdata?.state)?.name || "";
  const cityName = citylist.find(item => item._id === fitterdata?.city)?.name || "";

  const [selectedPost, setSelectedPost] = useState(null);

  return (
    <>
      {isLoading ? (
        <div className="loading">
          <Loader2 />
        </div>
      ) : (
        <>
          <Header />
          <div className="fitterprofile container-xxl px-0" style={{ marginTop: "8rem" }}>
            <div className="tab-box-section first">
              <Form noValidate validated={validated}>
                <div className="profile-images-container position-relative">
                  {/* Cover Image Input */}
                  <div className="cover-image-container">
                    <label
                      htmlFor="coverImageInput"
                      className="profile-image-container text-center"
                      style={{
                        backgroundColor: "#41464f",
                        height: "15rem",
                        borderRadius: "20px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        cursor: edittrue ? "pointer" : "default",
                        position: "relative",
                        overflow: "hidden",
                      }}
                    >
                      {/* Cover image display */}
                      {databasecoverimage ? (
                        <img
                          src={API_URL + "cover_images/" + databasecoverimage}
                          alt="Cover Preview"
                          style={{
                            minWidth: "100%",
                            minHeight: "100%",
                            objectFit: "cover",
                            borderRadius: "10px",
                          }}
                        />
                      ) : (<img
                        src={`/default-images/default_cover_image.jpg`}
                        alt="Cover Preview"
                        style={{
                          minWidth: "100%",
                          minHeight: "100%",
                          objectFit: "cover",
                          borderRadius: "10px",
                        }}
                      />)}
                    </label>
                  </div>

                  {/* Profile Image Input */}
                  <div
                    className="profile-image-wrapper ms-5"
                    style={{
                      transform: "translateY(-30%)",
                      zIndex: 3,
                      position: "relative",
                    }}
                  >
                    <div className="d-flex align-items-center circlepart">
                      <div className="profile-image" style={{ width: "170px", height: "170px", position: "relative", overflow: "hidden", borderRadius: "50%" }}>

                        <label
                          htmlFor="profileImageInput"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            width: "100%",
                            height: "100%",
                            cursor: edittrue ? "pointer" : "default",
                            position: "relative",
                          }}
                        >
                          {/* Profile image display */}
                          {databaseimage ? (
                            <img
                              src={API_URL + "images/" + databaseimage}
                              alt="Profile"
                              className="img-fluid"
                              style={{
                                width: "100%",
                                height: "100%",
                                borderRadius: "100%",
                                objectFit: "cover",
                              }}
                            />
                          ) : (<img
                            src={`/default-images/default_user_image.jpg`}
                            alt="Profile"
                            className="img-fluid"
                            style={{
                              width: "100%",
                              height: "100%",
                              borderRadius: "100%",
                              objectFit: "cover",
                            }}
                          />)}

                        </label>
                      </div>
                      <div className="ms-4 mt-3">
                        <div className="build_title main-title">{`${fitterdata?.firstname} ${fitterdata?.lastname}`}</div>
                        <div
                          className="little_text mt-2"
                          style={{ fontWeight: "500" }}
                        >
                          {/* Los Angeles, California */}
                          {`${cityName}, ${stateName}`}
                        </div>
                      </div>
                    </div>
                    <div className="row new-row">
                      <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 d-flex align-items-center gap-3 rfgregergreg" >
                        <a href={`tel:${fitterdata?.phone}`} className="border_box_view">
                          <div className="border_box_view_inner d-flex align-items-center">
                            <div className="box_icon">
                              <svg xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 64 64" height="512" viewBox="0 0 64 64" width="512"><g id="_x32_7-Phone" fill="#99ea24"><path d="m52.1478348 42.6777344-6.4785156-4.5263672c-.847168-.5908203-1.8374023-.9023438-2.8642578-.9023438-1.6328125 0-3.1655273.8007813-4.0991211 2.140625l-1.5039063 2.1552734c-2.5205078-1.6904297-5.3330097-4.0507813-8.0141621-6.7314453-2.6806641-2.6806641-5.0405273-5.4931641-6.7304688-8.0136719l2.1542969-1.5039063c1.0981445-.7646484 1.831543-1.9101563 2.0644531-3.2246094.2324219-1.3134766-.0605469-2.640625-.8261719-3.7392578l-4.5253906-6.4785156c-.946289-1.3535155-2.4731444-2.1621092-4.0849609-2.1621092-.5585938 0-1.1064453.0986328-1.6279297.2910156-.5922852.21875-1.144043.4873047-1.6850586.8271484l-.8945313.6298828c-.2236328.1738281-.4316406.3642578-.6308594.5634766-1.0913086 1.0908203-1.8657227 2.4716797-2.3027344 4.1044922-1.8647461 6.9902344 2.7548828 17.5605469 11.4951172 26.3007813 7.3398438 7.3398438 16.1577168 11.8994141 23.0117207 11.9003906h.0004883c1.1738281 0 2.2802734-.1367188 3.2890625-.40625 1.6328125-.4365234 3.0136719-1.2109375 4.1054688-2.3027344.1982422-.1982422.3876953-.40625.5908203-.6689453l.6303711-.8994141c.3081055-.4921875.5761719-1.0439453.7978516-1.640625.762207-2.0605469-.0073242-4.4101562-1.871582-5.7128906z" /></g></svg>
                            </div>
                            <div className="box_text_content m-0">
                              <div className="big_text">Call</div>
                            </div>
                          </div>
                        </a>
                        <a href={`mailto:${fitterdata?.email}`} className="border_box_view">
                          <div className="border_box_view_inner d-flex align-items-center">
                            <div className="box_icon">
                              <svg xmlns="http://www.w3.org/2000/svg" id="Layer_1" height="512" viewBox="0 0 32 32" width="512" data-name="Layer 1"><path d="m13.4932 11.5488a1.0116 1.0116 0 0 0 .5346.1322 1.3553 1.3553 0 0 0 .5454-.1712l12.0106-7.008a2.99 2.99 0 0 0 -2.5838-1.5018h-20a2.99 2.99 0 0 0 -2.5837 1.5019z" fill="#99ea24" /><path fill="#99ea24" d="m27 6.57v6.95a8.7994 8.7994 0 0 0 -3-.52 9.0136 9.0136 0 0 0 -9 9 8.2619 8.2619 0 0 0 .06 1h-11.06a3.0088 3.0088 0 0 1 -3-3v-13.43l11.49 6.71a3.1474 3.1474 0 0 0 3.02 0z" /><path fill="#99ea24" d="m24 15a7 7 0 0 0 0 14 1 1 0 0 0 0-2 5 5 0 1 1 5-5v1a1 1 0 0 1 -2 0v-1a3 3 0 1 0 -3 3 2.964 2.964 0 0 0 1.4708-.4014 2.9939 2.9939 0 0 0 5.5292-1.5986v-1a7.0085 7.0085 0 0 0 -7-7zm0 8a1 1 0 1 1 1-1 1.0006 1.0006 0 0 1 -1 1z" /></svg>
                            </div>
                            <div className="box_text_content m-0">
                              <div className="big_text">Email</div>
                            </div>
                          </div>
                        </a>
                        {
                          fitterdata?.website_url ? (<a href={
                            fitterdata?.website_url?.startsWith('http://') || fitterdata?.website_url?.startsWith('https://')
                              ? fitterdata.website_url
                              : `https://${fitterdata.website_url}`
                          } className="border_box_view" target="_blank" rel="noopener noreferrer">
                            <div className="border_box_view_inner d-flex align-items-center">
                              <div className="box_icon">
                                <svg xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 32 32" viewBox="0 0 32 32" fill="#99ea24"><g id="Grid" display="none" fill="#99ea24" /><g id="Webinar" /><g id="Assignment" /><g id="Article" /><g id="Audi" /><g id="Video_Tutorial" /><g id="Discussion_1_" /><g id="Resume" /><g id="Trophy" /><g id="Encyclopedia" /><g id="Smartphone" /><g id="Online_Lesson" /><g id="Webpage"><circle cx="6.44" cy="6.614" r=".804" /><circle cx="9.272" cy="6.614" r=".804" /><circle cx="12.104" cy="6.614" r=".804" /><path d="m20.071 20.191 2.623 8.622c.254.835 1.43.853 1.709.025l1.228-3.644c.09-.266.298-.474.564-.564l3.644-1.228c.827-.279.81-1.455-.025-1.709l-8.622-2.623c-.687-.208-1.329.434-1.121 1.121z" /><path d="m18.637 20.627c-.224-.734-.09-1.509.366-2.124.452-.609 1.17-.973 1.923-.973.237 0 .473.035.703.105l7.752 2.357v-13.721c0-2.05-1.67-3.72-3.72-3.72h-20.391c-2.05 0-3.72 1.67-3.72 3.72v16.65c0 2.06 1.67 3.73 3.73 3.73h15.188zm-15.287-11.736v-2.619c0-1.059.861-1.92 1.92-1.92h20.39c1.059 0 1.92.861 1.92 1.92v2.619z" /></g><g id="Search" /><g id="Registration" /><g id="Certificate_1_" /><g id="Review" /><g id="Ebook" /><g id="Online_Class_1_" /><g id="Schedule" /><g id="Idea" /><g id="Login" /><g id="Science" /><g id="Time" /><g id="Business" /><g id="Projector" /></svg>
                              </div>
                              <div className="box_text_content m-0">
                                <div className="big_text">Website</div>
                              </div>
                            </div>
                          </a>) : (
                            <a disabled className="border_box_view" style={{ border: "4px solid #3e444f" }} target="_blank" rel="noopener noreferrer">
                              <div className="border_box_view_inner d-flex align-items-center">
                                <div className="box_icon">
                                  <svg xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 32 32" viewBox="0 0 32 32" fill="#3e444f"><g id="Grid" display="none" fill="#3e444f" /><g id="Webinar" /><g id="Assignment" /><g id="Article" /><g id="Audi" /><g id="Video_Tutorial" /><g id="Discussion_1_" /><g id="Resume" /><g id="Trophy" /><g id="Encyclopedia" /><g id="Smartphone" /><g id="Online_Lesson" /><g id="Webpage"><circle cx="6.44" cy="6.614" r=".804" /><circle cx="9.272" cy="6.614" r=".804" /><circle cx="12.104" cy="6.614" r=".804" /><path d="m20.071 20.191 2.623 8.622c.254.835 1.43.853 1.709.025l1.228-3.644c.09-.266.298-.474.564-.564l3.644-1.228c.827-.279.81-1.455-.025-1.709l-8.622-2.623c-.687-.208-1.329.434-1.121 1.121z" /><path d="m18.637 20.627c-.224-.734-.09-1.509.366-2.124.452-.609 1.17-.973 1.923-.973.237 0 .473.035.703.105l7.752 2.357v-13.721c0-2.05-1.67-3.72-3.72-3.72h-20.391c-2.05 0-3.72 1.67-3.72 3.72v16.65c0 2.06 1.67 3.73 3.73 3.73h15.188zm-15.287-11.736v-2.619c0-1.059.861-1.92 1.92-1.92h20.39c1.059 0 1.92.861 1.92 1.92v2.619z" /></g><g id="Search" /><g id="Registration" /><g id="Certificate_1_" /><g id="Review" /><g id="Ebook" /><g id="Online_Class_1_" /><g id="Schedule" /><g id="Idea" /><g id="Login" /><g id="Science" /><g id="Time" /><g id="Business" /><g id="Projector" /></svg>
                                </div>
                                <div className="box_text_content m-0">
                                  <div className="big_text" style={{ color: "#3e444f" }}>Website</div>
                                </div>
                              </div>
                            </a>
                          )
                        }

                        {
                          fitterdata?.bioVideo ? (<button className="border_box_view" style={{ background: "none" }} onClick={(e) => {
                            handleShowbiovideo()
                            e.preventDefault();
                          }}>
                            <div className="border_box_view_inner d-flex align-items-center">
                              <div className="box_icon">
                                <svg xmlns="http://www.w3.org/2000/svg" width="475" height="445" viewBox="0 0 475 445" fill="#99ea24">
                                  <rect width="475" height="375" rx="50" fill="#99ea24" />
                                  <path d="M282.5 194.062C287.167 191.368 287.167 184.632 282.5 181.938L221 146.431C216.333 143.736 210.5 147.105 210.5 152.493V223.507C210.5 228.895 216.333 232.264 221 229.569L282.5 194.062Z" fill="#99ea24" stroke="#1E2025" stroke-width="20" />
                                  <rect y="405" width="475" height="20" rx="10" fill="#99ea24" />
                                  <circle cx="84" cy="415" r="30" fill="#99ea24" />
                                </svg>
                              </div>
                              <div className="box_text_content m-0">
                                <div className="big_text">Bio</div>
                              </div>
                            </div>
                          </button>) : (
                            <button className="border_box_view" style={{ background: "none", border: "4px solid #3e444f" }} disabled>
                              <div className="border_box_view_inner d-flex align-items-center">
                                <div className="box_icon">
                                  <svg xmlns="http://www.w3.org/2000/svg" width="475" height="445" viewBox="0 0 475 445" fill="#3e444f">
                                    <rect width="475" height="375" rx="50" fill="#3e444f" />
                                    <path d="M282.5 194.062C287.167 191.368 287.167 184.632 282.5 181.938L221 146.431C216.333 143.736 210.5 147.105 210.5 152.493V223.507C210.5 228.895 216.333 232.264 221 229.569L282.5 194.062Z" fill="#3e444f" stroke="#1E2025" stroke-width="20" />
                                    <rect y="405" width="475" height="20" rx="10" fill="#3e444f" />
                                    <circle cx="84" cy="415" r="30" fill="#3e444f" />
                                  </svg>
                                </div>
                                <div className="box_text_content m-0">
                                  <div className="big_text" style={{ color: "#3e444f" }}>Bio</div>
                                </div>
                              </div>
                            </button>)
                        }
                      </div>
                    </div>
                  </div>
                  {/* <div className="mx-3 text-part">
                    {`${fitterdata?.bio ?? ""}`}
                  </div> */}
                </div>
              </Form>
              <div className="row post-part">
                {
                  fitterposts.map((item, index) => {
                    return (
                      <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-6 col-sm-12 col-12 mt-5" key={index}>

                        <div
                          className="image-hover-wrapper"
                          onClick={() => {
                            setSelectedImage(API_URL + "posts/" + item?.post_image)
                          }}
                        >
                          {item?.post_thumbnail && (
                            <img
                              src={API_URL + "posts/" + item?.post_image}
                              alt="Profile"
                              className="img-fluid"
                            />
                          )}

                          <div className="hover-overlay" onClick={(e) => {
                            e.stopPropagation();
                            setSelectedPost(item)
                            handleShow()
                          }}
                            style={{ fontSize: "40px", fontWeight: "900" }}
                          >VIEW POST</div>

                          <div
                            className="resize-button d-flex align-items-center justify-content-center"
                            style={{
                              width: "2rem",
                              height: "2rem",
                              borderRadius: "5px",
                              backgroundColor: "#ffffff",
                              position: "absolute",
                              bottom: "10px",
                              right: "10px",
                              cursor: "pointer",
                              zIndex: 2,
                            }}
                            onClick={(e) => {
                              e.preventDefault();
                              setSelectedImage(API_URL + "posts/" + item?.post_image);
                              setShow(true);
                            }}
                          >
                            <svg xmlns="http://www.w3.org/2000/svg" id="Layer_1" height="512" viewBox="0 0 512 512" width="512" data-name="Layer 1" fill=""><path d="m100 0h312a100.193 100.193 0 0 1 100 100v312a100.193 100.193 0 0 1 -100 100h-312a100.193 100.193 0 0 1 -100-100v-312a100.193 100.193 0 0 1 100-100zm6 387.251a18.754 18.754 0 0 0 18.75 18.749h98.133a18.751 18.751 0 1 0 0-37.5h-52.865l69.8-69.8a18.752 18.752 0 0 0 -26.518-26.523l-69.8 69.81v-52.87a18.751 18.751 0 0 0 -37.5 0zm300-262.5a18.755 18.755 0 0 0 -18.75-18.751h-98.133a18.751 18.751 0 1 0 0 37.5h52.87l-69.81 69.8a18.753 18.753 0 0 0 26.523 26.523l69.8-69.81v52.871a18.751 18.751 0 0 0 37.5 0z" fill-rule="evenodd" fill="#99ea24" /></svg>
                          </div>
                        </div>


                        {selectedImage && (
                          <div
                            className="modal-overlay"
                            style={{
                              position: "fixed",
                              top: 0, left: 0, right: 0, bottom: 0,
                              backgroundColor: "rgba(0, 0, 0, 0.8)",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              zIndex: 9999
                            }}
                            onClick={() => setSelectedImage(null)}
                          >
                            <img
                              src={selectedImage}
                              alt="Zoomed"
                              style={{ maxHeight: "90%", maxWidth: "90%", objectFit: "contain" }}
                            />
                          </div>
                        )}

                        <style>{
                          `
                          .fitterprofile .border_box_view.disabled {
                              pointer-events: none;
                              opacity: 0.5;
                              cursor: not-allowed;
                            } 


                          // @media only screen and (min-width: 320px) and (max-width: 480px) {
                            
                          // }
                          
        .fitterprofile .image-hover-wrapper {
    position: relative;
    overflow: hidden;
    border-radius: 10px;
    aspect-ratio: 1 / 1;
    background-color: #41464f;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }

  .fitterprofile .image-hover-wrapper img {
    min-height: 100%;
    min-width: 100%;
    /* Change from object-fit: contain to object-fit: cover */
    object-fit: cover;
    transition: transform 0.3s ease;
    width: 100%;
    height: 100%;
  }

                          
                          @media screen and (min-width: 991px){
                            .rfgregergreg {
                              overflow-x: auto;
                              max-width: fit-content;
                              justify-content: end;
                              }
                          }

                          @media screen and (min-width:320px) and (max-width: 450px){
                            .d-flex.align-items-center.gap-3.rfgregergreg {
                              gap: 10px !important;
                            } 
                          }

                          // .image-hover-wrapper img {
                          //   min-height: 100%;
                          //   min-width: 100%;
                          //   object-fit: contain;
                          //   transition: transform 0.3s ease;
                          // }

                          .fitterprofile .image-hover-wrapper:hover img {
                            transform: scale(1.05);
                            }

                          .fitterprofile .image-hover-wrapper:hover .resize-button {
                            background-color: transparent !important;
                          }
                          .fitterprofile .image-hover-wrapper:hover .resize-button svg path{
                            fill: #262a31 !important;
                          }

                          .fitterprofile .hover-overlay {
                            position: absolute;
                            top: 0;
                            left: 0;
                            right: 0;
                            bottom: 0;
                            background-color: rgba(153, 234, 36, 0.85); /* translucent green */
                            color: black;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            font-weight: 700;
                            font-size: 22px;
                            opacity: 0;
                            transition: opacity 0.3s ease;
                          }

                          .fitterprofile .image-hover-wrapper:hover .hover-overlay {
                            opacity: 1;
                          }

                          @media screen and (max-width: 641px){
                            .fitterprofile .circlepart{
                              margin-top: 3rem !important;
                            }
                          }

                          @media screen and (min-width: 450px) and (max-width: 575px){
                            .fitterprofile .circlepart{
                              margin-top: 4rem !important;
                            }
                          }

                          `}</style>
                      </div>
                    )
                  })
                }
              </div>
            </div>
          </div>
          {
            fitterposts.length === 0 && (
              <></>
              // <div className="no-data-found">
              //   <div className='no-data-img'>
              //     <img src={require("../../assets/images/logo_text.png")} alt="" />
              //   </div>
              //   <div className="no-data-text">
              //     <h3>No Posts Found</h3>
              //   </div>
              // </div>
            )
          }
          <ContactUs />
          <style>
            {`
            .fitterprofile .border_box_view {
              height: 4.5rem;
              margin-top: 3rem;
            }
            .fitterprofile .big_text {
              font-size: 20px;
              font-weight: 800;
              line-height: 48px;
            }

            @media screen and (max-width: 575px){
                .fitterprofile .eferfefef{
                  margin-top: 10px;
                }
            }
            @media screen and (max-width: 450px){
                .fitterprofile .btn-create{
                  font-size: 16px;
                }
            }
            .fitterprofile .btn-create.ubuyuy{
              background-color: #f34c12 !important;
              color: #ffffff !important;
            }
            .fitterprofile .btn-create.vergrgre{
              background-color: #404650 !important;
              color: #ffffff !important;
            }
            .fitterprofile .btn-create, .fitterprofile .ubuyuy{
              font-weight: 600 !important;
              }
            .fitterprofile .custom-file-upload {
                  position: relative;
                  height: 15rem;
                  border-radius: 15px;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  cursor: pointer;
                  overflow: hidden;
                  background-color: #41464f;
                  transition: all 0.3s ease;
                }
                
                .fitterprofile .custom-file-upload:hover {
                  border-color: #666;
                  background-color: #f0f0f0;
                }
                
                .fitterprofile .file-input-hidden {
                  position: absolute;
                  top: 0;
                  left: 0;
                  width: 100%;
                  height: 100%;
                  opacity: 0;
                  cursor: pointer;
                  z-index: 2;
                }
                
                .fitterprofile .file-upload-placeholder {
                  display: flex;
                  flex-direction: column;
                  align-items: center;
                  justify-content: center;
                  text-align: center;
                  color: #666;
                }
                
                .fitterprofile .upload-icon {
                  font-size: 2rem;
                  margin-bottom: 0.5rem;
                  color: #666;
                }

                .fitterprofile .profile-image-wrapper{
                  display: flex;
                  align-items: center;
                  justify-content: space-between;
                }

                .fitterprofile .border_box_view_inner{
                  margin: 0 2rem;
                }

                @media screen and (max-width: 1260px){
                  .fitterprofile .border_box_view_inner{
                    margin: 0 1rem;
                    transition: all 0.5s ease-in-out;
                  }
                }

                @media screen and (min-width: 1130px){
                  .fitterprofile .profile-images-container.position-relative{
                    max-height: 22.5rem !important;
                  }
                }
                @media screen and (min-width: 992px) and (max-width: 1129px){
                  .fitterprofile .profile-images-container.position-relative{
                    max-height: 21rem !important;
                  }
                }

                @media screen and (max-width: 991px){
                  .fitterprofile .profile-image-wrapper{
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    width: calc(100% - 6rem);
                  }
                  .fitterprofile .profile-images-container.position-relative{
                    max-height: 32rem !important;
                  }
                  
                  .fitterprofile .circlepart{
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    width: 100%;
                    margin-top: 2rem;
                  }
                    .fitterprofile .circlepart .ms-4.mt-3{
                      display: flex;
                      flex-direction: column;
                      align-items: center;  
                      margin-left: 0 !important;
                    }
                }
                    @media only screen and (min-width: 320px) and (max-width: 480px) {
                      .fitterprofile .circlepart .ms-4.mt-3 .build_title {
                        font-size: 21px !important;
                        white-space: nowrap; 
                        overflow: hidden; 
                        text-overflow: ellipsis; 
                        width: 285px;
                        text-align: center;
                        transition: all 0.5s ease-in-out;
                      }
                    }

                @media screen and (max-width: 991px){
                  .fitterprofile .circlepart .ms-4.mt-3 .build_title{
                    text-align: center;
                  }
                }
                @media screen and (max-width: 640px){
                  .fitterprofile .profile-image-wrapper{
                    margin-top: 4rem;
                    min-width: -webkit-fill-available;
                    margin-left: 0 !important;
                  }
                  .fitterprofile .rfgregergreg{
                    flex-direction: column !important;
                    align-items: center !important;
                    justify-content: center !important;
                  }
                  .fitterprofile .tab-box-section.first{
                    padding-bottom: 40px !important;
                  }
                  .fitterprofile .profile-images-container.position-relative{
                    max-height: 60rem !important;
                  }
                  
                  .fitterprofile .new-row{
                    min-width: -webkit-fill-available !important;
                  }
                  .fitterprofile .new-row .rfgregergreg{
                    min-width: -webkit-fill-available !important;
                    // padding-left: 0 !important;
                    // padding-right: 0 !important;
                  }
                  .fitterprofile .new-row .rfgregergreg a, .fitterprofile .new-row .rfgregergreg button{
                    min-width: -webkit-fill-available !important;
                    margin-top:0 !important;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                  }
                  .fitterprofile .new-row .rfgregergreg a:first-child{
                    margin-top: 3rem !important;
                  }
                  .fitterprofile .post-part {
                    margin-top: -12rem !important;
                    transition: all 0.5s ease-in-out;
                }
                }

                @media only screen and (min-width: 671px) and (max-width: 991px) {
                  .fitterprofile .border_box_view {
                    padding: 1rem 0.3rem !important;
                  }
                }

                @media only screen and (min-width: 992px) and (max-width: 1800px){
                  .fitterprofile .border_box_view{
                    padding: 1rem 0rem;
                  }
                }

                @media screen and (min-width: 991px) and (max-width: 1550px){
                  .fitterprofile .build_title.main-title{
                    white-space: nowrap; 
                    
                    text-overflow: ellipsis; 
                    width: 180px;
                    transition: all 0.5s ease-in-out;
                  }
                }

                @media screen and (max-width: 991px){
                  .fitterprofile .box_text_content{
                    display: none;
                  }
                  .fitterprofile .border_box_view_inner{
                    margin: 0 1rem;
                    transition: all 0.5s ease-in-out;
                  }
                }

                @media only screen and (max-width: 1125px){
                  .fitterprofile .box_text_content{
                    display: flex;
                  }
                }

                @media screen and (max-width: 449px){
                  .fitterprofile .profile-image{
                    width: 120px !important;
                    height: 120px !important;
                  }
                }

                @media screen and (min-width: 991px) and (max-width: 1130px){
                  .fitterprofile .profile-image{
                    width: 130px !important;
                    height: 130px !important;
                    transition: all 0.6s ease-in-out;
                  }
                  .fitterprofile .profile-image-wrapper{
                    margin-left: 1rem !important;
                  }
                  .fitterprofile .border_box_view_inner{
                    gap: 8px !important;
                  }
                  .fitterprofile .rfgregergreg{
                    gap: 8px !important;
                  }
                }
                
                @media screen and (min-width:450px) and (max-width: 575px){
                  .fitterprofile .profile-image{
                    width: 120px !important;
                    height: 120px !important;
                    }
                }

                @media screen and (max-width: 670px){
                  // .fitterprofile .border_box_view_inner{
                  //   margin: 0 1.3rem;
                  // }
                  .fitterprofile .border_box_view{
                    padding: 0;
                  }
                }
                .fitterprofile .tab-box-section.first{
                  margin-top: 10rem;
                }
                @media screen and (max-width: 990px){
                  .fitterprofile .tab-box-section.first{
                    margin-top: 8rem;
                  }
                }
                @media screen and (max-width: 768px){
                  .fitterprofile .tab-box-section.first{
                    margin-top: 6rem;
                  }
                }
                
            `}
          </style>
        </>
      )
      }
      <Modal size="lg" centered show={show} onHide={handleClose} className="card-radius popup-modal-dark darkest-modal">
        <Modal.Body className="bg_dark_black card-dark card-radius dark_modal_mobile">
          <div className="d-flex align-items-center justify-content-between">
            <div className="build_title d-flex">
              <div className="boxy-icon">
                {databaseimage ? (
                  <img
                    src={API_URL + "images/" + databaseimage}
                    alt="Profile"
                    className="img-fluid"
                    style={{
                      width: "100%",
                      height: "100%",
                      borderRadius: "100%",
                      objectFit: "cover",
                      verticalAlign: "unset"
                    }}
                  />
                ) : (<img
                  src={`/default-images/default_user_image.jpg`}
                  alt=""
                  className="img-fluid"
                  style={{
                    width: "100%",
                    height: "100%",
                    borderRadius: "100%",
                    objectFit: "cover",
                    verticalAlign: "unset"
                  }}
                />)}
              </div>
              <div className="ms-2 custom-text">
                <div className="build_title">
                  {`${fitterdata?.firstname} ${fitterdata?.lastname}`}
                </div>
                <div
                  className="little_text mt-2"
                  style={{ fontWeight: "500" }}
                >
                  {`${cityName}, ${stateName}`}
                </div>
              </div>
            </div>
            <button className="modal-close-btn" onClick={handleClose}>&times;</button>
          </div>

          <h5 className="modal-post-title">{selectedPost?.title}</h5>
          <p className="modal-post-description">
            {selectedPost?.descripation}
          </p>

          <div className="post-image-wrapper">
            <img
              src={API_URL + "posts/" + selectedPost?.post_image}
              alt="Post"
              className="modal-image mt-2"
            />
          </div>
        </Modal.Body>
        <style>{`
                              // .darkest-modal .card-dark.dark_modal_mobile {
                              //   padding: 20px 16px 16px;
                              // }
                              @media only screen and (min-width: 320px) and (max-width: 480px) {
                                .darkest-modal .card-dark.dark_modal_mobile {
                                    padding: 20px 16px 16px;
                                }
                              }

                              .darkest-modal .modal-post-title{
                                margin-top: 2rem;
                              }
                              .darkest-modal .modal-post-description{
                                margin-top: 1.2rem;
                              }
                              .darkest-modal .card-dark{
                                padding: 1.5rem 2rem;
                              }
                              .darkest-modal .bg_dark_black{
                                background-color: #272a31 !important;
                              }

                              @media only screen and (max-width: 768px) {
                                .darkest-modal .modal-dialog {
                                    margin-left: auto !important;
                                    margin-right: auto !important;
                                }
                              }


                              .darkest-modal .card-radius {
                                border-radius: 20px !important;
                              }
                                // @media only screen and (max-width: 768px) {
                                //     .modal-dialog {
                                //         margin: var(--bs-modal-margin) !important;
                                //     }
                                // }
                            `}</style>
      </Modal>

      <Modal size="lg" centered show={showbiovideo} onHide={handleClosebiovideo} className="card-radius popup-modal-dark darkest-modal">
        <Modal.Body className="bg_dark_black card-dark card-radius dark_modal_mobile">
          <div className="d-flex align-items-center justify-content-between">
            <div className="build_title d-flex">
              <div className="boxy-icon">
                {databaseimage ? (
                  <img
                    src={API_URL + "images/" + databaseimage}
                    alt="Profile"
                    className="img-fluid"
                    style={{
                      width: "100%",
                      height: "100%",
                      borderRadius: "100%",
                      objectFit: "cover",
                      verticalAlign: "unset"
                    }}
                  />
                ) : (<img
                  src={`/default-images/default_user_image.jpg`}
                  alt="Profile"
                  className="img-fluid"
                  style={{
                    width: "100%",
                    height: "100%",
                    borderRadius: "100%",
                    objectFit: "cover",
                    verticalAlign: "unset"
                  }}
                />)}</div>
              <div className="ms-2 custom-text">
                <div className="build_title">
                  {`${fitterdata?.firstname} ${fitterdata?.lastname}`}
                </div>
                <div
                  className="little_text mt-2"
                  style={{ fontWeight: "500" }}
                >
                  {`${cityName}, ${stateName}`}
                </div>
              </div>
            </div>
            <button className="modal-close-btn" onClick={handleClosebiovideo}><IoClose size={24} /></button>
          </div>
          <div className="post-image-wrapper">
            <video
              key={fitterdata ? fitterdata?.bioVideo : fitterdata?.bioVideo}
              playsInline
              autoPlay={false}
              preload="metadata"
              controls
              // preload="metadata"
              style={{
                width: "100%",
                height: "100%",
                borderRadius: "10px",
              }}
              controlsList="nodownload"
            >
              <source
                src={API_URL + "attachment/" + fitterdata?.bioVideo + "#t=0.1"}
                type="video/mp4"
              />
              Your browser does not
              support HTML5 video.
            </video>
          </div>
        </Modal.Body>
        <style>{`
          // .darkest-modal .card-dark.dark_modal_mobile {
          //   padding: 20px 16px 16px;
          // }
          @media only screen and (min-width: 320px) and (max-width: 480px) {
            .darkest-modal .card-dark.dark_modal_mobile {
                padding: 20px 16px 16px;
            }
          }
          .darkest-modal .card-dark{
                                padding: 1.5rem 2rem;
                              }
                              .darkest-modal .bg_dark_black{
                                background-color: #272a31 !important;
                              }

                              @media only screen and (max-width: 768px) {
                                .darkest-modal .modal-dialog {
                                    margin-left: auto !important;
                                    margin-right: auto !important;
                                }
                              }
            // @media only screen and (max-width: 768px) {
            //     .modal-dialog {
            //         margin: var(--bs-modal-margin) !important;
            //     }
            // }
        `}
        </style>
      </Modal>
      <style>{`
       .boxy-icon{
                            width: 45px !important;
                            height: 45px !important;
                          }
                          .custom-text .build_title{
                            font-size: 16px;
                          }
                          .custom-text .little_text{
                            font-size: 11px;
                          }
                            .post-modal-backdrop {
                            position: fixed;
                            top: 0; left: 0; right: 0; bottom: 0;
                            background: rgb(30 31 37 / 75%);
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            z-index: 9999;
                            opacity:0.6;
                          }

                          .post-modal-content {
                            background: #272a31;
                            color: #fff;
                            padding: 2rem;
                            border-radius: 15px;
                            width: 90%;
                            max-width: 550px;
                            position: relative;
                          }

                          .modal-close-btn {
                            // position: absolute;
                            // top: 15px;
                            // right: 20px;
                            background: transparent;
                            border: none;
                            color: white;
                            font-size: 3rem;
                            cursor: pointer;
                          }

                          .user-avatar {
                            width: 50px;
                            height: 50px;
                            background: #ccc;
                            border-radius: 50%;
                          }

                          .user-name {
                            margin: 0;
                            font-weight: bold;
                          }

                          .user-location {
                            margin: 0;
                            font-size: 12px;
                            color: #bbb;
                          }

                          .modal-post-title {
                            margin-top: 1rem;
                            font-size: 18px;
                            font-weight: bold;
                          }

                          .modal-post-description {
                            font-size: 14px;
                            color: #c4c4c4;
                          }
                          
                          .post-image-wrapper {
                            margin-top: 1.5rem;
                            text-align: center;
                          }

                          .modal-image {
                            max-width: 100%;
                            border-radius: 10px;
                          }
      `}</style>
    </>
  );
}

export default FitterProfile;


